import {
  STRIPE_DEV_TOOLS_IFRAME_TITLE,
  STRIPE_FLOATING_IFRAME_MAX_EDGE_PX,
} from './stripe-floating-iframe-constants';
import { isStripeIframeInProtectedContainer } from './is-stripe-iframe-in-protected-container';

/**
 * Stripe.js mounts controller / 3DS / network helpers as small fixed iframes on `document.body`
 * (not inside Payment Element). They must never be stripped — removing them shows "Provisional headers"
 * in DevTools and breaks SetupIntent / mandate / 3DS.
 */
const isStripeHostedPaymentIframe = (iframe: HTMLIFrameElement): boolean => {
  let raw = '';
  try {
    raw = iframe.getAttribute('src') || iframe.src || '';
  } catch {
    return false;
  }
  const s = raw.toLowerCase();
  return (
    s.includes('js.stripe.com') ||
    s.includes('hooks.stripe.com') ||
    s.includes('m.stripe.network')
  );
};

export const removeStripeFloatingIframes = (): void => {
  if (!document.body) return;
  document.querySelectorAll('iframe').forEach((iframe: HTMLIFrameElement) => {
    const title = iframe.getAttribute('title') || '';
    if (title === STRIPE_DEV_TOOLS_IFRAME_TITLE) {
      iframe.remove();
      return;
    }
    if (isStripeHostedPaymentIframe(iframe)) return;
    if (isStripeIframeInProtectedContainer(iframe)) return;
    const computedStyle = window.getComputedStyle(iframe);
    const isFloatingButton =
      (computedStyle.position === 'fixed' &&
        (computedStyle.bottom !== 'auto' || computedStyle.right !== 'auto')) ||
      (computedStyle.position === 'fixed' &&
        parseInt(computedStyle.width, 10) < STRIPE_FLOATING_IFRAME_MAX_EDGE_PX &&
        parseInt(computedStyle.height, 10) < STRIPE_FLOATING_IFRAME_MAX_EDGE_PX);
    if (isFloatingButton) iframe.remove();
  });
};
